<!DOCTYPE html>
<html lang="tr">
  <head> </head>
  <div id="xxx">dsadasdsa</div>
  <body>
    <!-- Masthead-->
    <header class="masthead">
      <div class="container position-relative">
        <div class="row justify-content-center">
          <div class="col-xl-6">
            <div class="text-center text-white">
              <!-- Page heading-->
              <h1 class="mb-5">Patent Chest'e Hoşgeldiniz</h1>
              <h3>Demo hesabı için</h3>
              <h3 style="color: red">patentchest@gmail.com</h3>
              <h3>adresine e-posta gönderebilirsiniz.</h3>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Icons Grid-->
    <div class="row justify-content-center">
      <section class="features-icons bg-light text-center">
        <div class="container">
          <div class="row">
            <!-- <div class="col-lg-4"> -->
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
              <!-- <div class="features-icons-icon d-flex">
                <i class="bi-window m-auto text-primary"></i>
              </div> -->
              <h3>Kullanım Kolaylığı</h3>
              <p class="lead mb-0">
                Patent-Chest olabildiğince basit bir yapıda kurgulanmıştır.
              </p>
            </div>
            <!-- </div> -->
            <!-- <div class="col-lg-4"> -->
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
              <!-- <div class="features-icons-icon d-flex">
                <i class="bi-layers m-auto text-primary"></i>
              </div> -->
              <h3>Veri Güvenliği ve Kullanıcı Yetkilendirmesi</h3>
              <p class="lead mb-0">
                Patent Chest, Google Bulut Platformu üzerinden çalışmaktadır.
                Kullanıcı bilgileri, verileri ve dosyaları Google Serverlarında
                şifreli olarak tutulmaktadır. Kullanıcı tipine göre erişim yetki
                sınırlandırması yapılabilmektedir.
              </p>
            </div>
            <!-- </div> -->
            <!-- <div class="col-lg-4"> -->
            <div class="features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3">
              <!-- <div class="features-icons-icon d-flex">
                <i class="bi-terminal m-auto text-primary"></i>
              </div> -->
              <h3>Patent Kanuna Uygun Şekilde Hazırlanmıştır</h3>
              <p class="lead mb-0">
                Bu web sitesinin tamamı patent kanuna uyumlu olacak şekilde
                kurgulanmıştır.
              </p>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </section>
    </div>
    <!-- Footer-->
    <footer class="footer bg-light">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 h-100 text-center text-lg-start my-auto">
            <ul class="list-inline mb-2">
              <li class="list-inline-item"><a href="#!">Hakkında</a></li>
              <li class="list-inline-item">⋅</li>
              <li class="list-inline-item"><a href="#!">İletişim</a></li>
              <li class="list-inline-item">⋅</li>
              <li class="list-inline-item">
                <a href="#!">Kullanım Sözleşmesi</a>
              </li>
              <li class="list-inline-item">⋅</li>
              <li class="list-inline-item">
                <a href="#!">Gizlilik Politikamız</a>
              </li>
            </ul>
            <p class="text-muted small mb-4 mb-lg-0">
              &copy; Patent Chest 2021. Tüm hakları saklıdır.
            </p>
          </div>
          <div class="col-lg-6 h-100 text-center text-lg-end my-auto">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-4">
                <a href="#!"><i class="bi-facebook fs-3"></i></a>
              </li>
              <li class="list-inline-item me-4">
                <a href="#!"><i class="bi-twitter fs-3"></i></a>
              </li>
              <li class="list-inline-item">
                <a href="#!"><i class="bi-instagram fs-3"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </body>
</html>
